import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_decrease",
  "use": "icon-icon_decrease-usage",
  "viewBox": "0 0 8 8",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8 8\" id=\"icon-icon_decrease\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h8v8H0z\" /><path d=\"M1.988 2.022h4.009c.323 0 .617.218.757.56a1.35 1.35 0 0 1-.124 1.24l-2.004 2.86a.791.791 0 0 1-.634.34.791.791 0 0 1-.633-.34l-2.004-2.86a1.35 1.35 0 0 1-.124-1.24c.14-.342.434-.56.757-.56Z\" fill=\"#30C696\" fill-rule=\"nonzero\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol